import { Controller } from '@hotwired/stimulus'
import { debounce } from 'lodash-es'

// Opens and closes a native popover. The element that opens it is passed as the
// popover's source, so CSS anchor positioning can place the popover against it
// and light dismiss treats clicks on it as inside.
export default class extends Controller<HTMLElement> {
  static targets = ['popover', 'form']

  declare readonly popoverTarget: HTMLElement
  declare readonly formTarget: HTMLFormElement
  declare readonly hasFormTarget: boolean

  show (event?: Event): void {
    const source = event?.currentTarget
    this.showFrom(source instanceof HTMLElement ? source : undefined)
  }

  hide (): void {
    if (this.isOpen) this.popoverTarget.hidePopover()
  }

  toggle (event: Event): void {
    this.isOpen ? this.hide() : this.show(event)
  }

  // Shows the popover while the input has text, and submits the form target so it can fill in.
  search (event: Event): void {
    this.searchDebounced(event.target as HTMLInputElement)
  }

  private readonly searchDebounced = debounce((input: HTMLInputElement) => {
    input.value === '' ? this.hide() : this.showFrom(input)
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }, 300)

  private showFrom (source: HTMLElement | undefined): void {
    if (this.isOpen) return
    this.popoverTarget.showPopover({ source })
  }

  private get isOpen (): boolean {
    return this.popoverTarget.matches(':popover-open')
  }
}
